
//Naming: "teammate" is kept only where code mirrors backend names
//(api/v1/my_teammate, TeammateConversation) — i.e. this file, the API client
//and the messages-querying composable. Everything user-adjacent is named
//"agent" instead (route /agent, Agent.vue, goToAgent), and user-facing copy
//must never say "teammate": employee-facing = "Arist Agent",
//admin-facing = "Employee Agent".

//Teammate message roles (mirror the api/v1/my_teammate role enum)
export const teammateMessageRoles = {
  USER: 'user',
  ASSISTANT: 'assistant',
}

//Teammate conversation states (mirror TeammateConversation#state)
export const teammateConversationStates = {
  DORMANT: 'dormant',
  ACTIVE: 'active',
  UNRESPONSIVE: 'unresponsive',
}

//Org-wide teammate delivery channels (mirror Organization#teammate_delivery_channel,
//which can also hold e.g. 'slack'). The agent surface in this app is only live
//when the org routes delivery to the tab, i.e. the channel is TEAMS — see
//useCurrentOrganization().
export const teammateDeliveryChannels = {
  TEAMS: 'teams',
}
